// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__YYZvx","container":"styles_container__2bY2t","title":"styles_title__2nKUG","wrapper":"styles_wrapper__2Q6ml","answer":"styles_answer__1bhEA"};